import React, { useId } from 'react';

import { Separator } from '../styled';
import TextPrompt from '../text-prompt';
import { RadioGroupContainer, RadioGroupLabel, RadioInput, RadioOption, RadioOptionsWrapper } from './styled';

interface RadioOptionType {
	id: number;
	label: string;
	value: string;
}

interface IRadioGroup extends Omit<React.ComponentPropsWithoutRef<'input'>, 'type'> {
	label?: string;
	error?: string;
	isvalid?: boolean;
	options: readonly RadioOptionType[];
	value?: string;
}

// eslint-disable-next-line react/display-name
export const TypeRadioGroup = React.forwardRef<HTMLInputElement, IRadioGroup>(
	({ label, error, isvalid, options, name, value, onChange, ...props }, ref) => {
		const generatedId = useId();
		const groupId = name || generatedId;
		const errorId = error ? `${groupId}-error` : undefined;

		return (
			<RadioGroupContainer
				role='radiogroup'
				aria-labelledby={label ? `${groupId}-label` : undefined}
			>
				{label && <RadioGroupLabel id={`${groupId}-label`}>{label}</RadioGroupLabel>}
				<RadioOptionsWrapper
					iserror={error}
					isvalid={isvalid}
				>
					{options.map((option) => (
						<RadioOption
							key={option.id}
							htmlFor={`${groupId}-${option.value}`}
						>
							<RadioInput
								{...props}
								type='radio'
								id={`${groupId}-${option.value}`}
								name={name}
								value={option.value}
								checked={value === option.value}
								onChange={onChange}
								ref={ref}
								aria-describedby={errorId}
							/>
							{option.label}
						</RadioOption>
					))}
				</RadioOptionsWrapper>
				{!!error && (
					<>
						<Separator />
						<TextPrompt
							prompt={error}
							status={false}
							id={errorId}
							role='alert'
						/>
					</>
				)}
			</RadioGroupContainer>
		);
	}
);
